export default __webpack_public_path__ + "static/media/calculator-white.0c729b36.png";